import { render, staticRenderFns } from "./PracticeView.vue?vue&type=template&id=755537be&scoped=true&"
import script from "./PracticeView.vue?vue&type=script&lang=js&"
export * from "./PracticeView.vue?vue&type=script&lang=js&"
import style0 from "./PracticeView.vue?vue&type=style&index=0&id=755537be&prod&scoped=true&lang=css&"
import style1 from "./PracticeView.vue?vue&type=style&index=1&id=755537be&prod&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755537be",
  null
  
)

export default component.exports